/*
 * Public API Surface of chat-bot
 */

export * from './lib/chat-bot.service';
export * from './lib/chat-bot.component';
export * from './lib/chat-bot.module';
